import { useTheme as useThemeContext } from '../providers/ThemeProvider';

/**
 * Hook personalizado para acceder al contexto de tema
 * @returns {Object} Objeto con propiedades y métodos del tema
 */
export const useTheme = () => {
  return useThemeContext();
};

export default useTheme;

